import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE,
  getFontContrastColor
} from '../../../themes'
export const StyleModal = styled.div`
  .content-modal {
    border-radius: 16px;
    z-index: 9;
    color: #0E0E0F;
    position: fixed;
    background: #FFF;
    height: auto;
    top: 32%;
    width: 500px;
    font-size: 20px;
    text-align: center;
    left: 0;
    right: 0;
    margin: auto;
    -webkit-animation-name: example;  /* Safari 4.0 - 8.0 */
    -webkit-animation-duration: 0.5s;  /* Safari 4.0 - 8.0 */
    animation-name: example;
    animation-duration: 0.5s;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

/* Safari 4.0 - 8.0 */
  @-webkit-keyframes example {
    0%   {
      padding-left: 50px;
      padding-right: 50px;
    }
    100%  {
      padding-left: 40px;
      padding-right: 40px;
    }
  }

  /* Standard syntax */
  @keyframes example {
    0%   {
      padding-left: 50px;
      padding-right: 50px;
    }
    100%  {
      padding-left: 40px;
      padding-right: 40px;
    }
  }

  .head-modal{
    font-family: LibreBaskervilleBold;
    font-size: ${FONT_SIZE.XXL};
    font-weight: bold;
    letter-spacing: 1px;
  }

  .description{
    margin-top: 20px;
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.BLACK_1};
    margin-bottom: 10px;
  }

  .p-description{
    white-space: pre-wrap;
  }

  .modal-btn-confirm{
    margin-top: 40px;
    width: 196px;
    margin-bottom: 0px;
    font-size: ${FONT_SIZE.XXS};
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    margin-left: 10px;
    color: ${({ colorTheme }) => getFontContrastColor(colorTheme)};
    float: none;
  }
`
